import { Button, Dialog, Grid, Typography } from '@mineral/core';
import { UserSessionExpiredIcon } from 'assets/icons/UserSessionExpiredIcon';
import React from 'react';
import { RefereshPopupDescription, RefereshPopupTitle } from './Enums';
import { AccessChangedIcon } from 'assets/icons/AccessChangedIcon';

interface IRefreshPageProps {
  isSessionExpired?: boolean;
}
export const RefreshPopup: React.FC<IRefreshPageProps> = ({
  isSessionExpired,
}) => {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
    window.location.reload();
  };
  return (
    <Dialog open={open} aria-labelledby="responsive-dialog-title">
      <Grid
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        {isSessionExpired ? (
          <UserSessionExpiredIcon
            sx={(theme) => ({
              width: theme.spacing(20),
              height: theme.spacing(25),
            })}
          />
        ) : (
          <AccessChangedIcon
            sx={(theme) => ({
              width: theme.spacing(20),
              height: theme.spacing(25),
            })}
          />
        )}

        <Grid item sx={{ textAlign: 'center' }}>
          <Typography variant="h4">
            {isSessionExpired
              ? RefereshPopupTitle('sessionExpired')
              : RefereshPopupTitle('')}
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            {isSessionExpired
              ? RefereshPopupDescription('sessionExpired')
              : RefereshPopupDescription('')}
          </Typography>
        </Grid>
        <Grid item sx={{ mt: 2 }}>
          <Button onClick={handleClose} variant="contained" autoFocus>
            Refresh
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};
